import { TextField, withStyles } from '@material-ui/core';

export const StyledTextField = withStyles(({ palette, spacing }) => ({
  root: {
    width: '100%',
    marginBottom: spacing(4),
    '& label': {
      color: palette.gray.main,
    },
    '& .MuiInput-underline.Mui-disabled:before': {
      borderBottomStyle: 'solid',
    },
  },
  // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
}))(TextField);
